import apiCreator from './util/ApiCreator';
const api = apiCreator('/api/dealer-portal/dealer-products');

export default {

    searchProducts (request) {
        return api.post(`/search`, request);
    },
    getProduct(productId) {
        return api.get(`/product/${productId}`);
    },
    getProducts(productIds) {
        return api.get(`/products`, { params : { ids : productIds.join(',') }});
    },
    getDealerFeedFile() {
        return api.get(`/dealer-feed-file`);
    },
    getCategories () {
        return api.get(`/categories`);
    },
}
